import axios from 'axios';

export class MetadataService {
    getMetadata = async () => {
        return await axios.get('api/metadata');
    };

    findById = async (id) => {
        return await axios.post('api/metadata/findbyid?id=' + id);
    };

    getRegion = async () => {
        return await axios.get('api/region');
    };

    getCountries = async () => {
        return await axios.get('/api/country/countries');
    };

    getRegionCountries = async (applicationId) => {
        return await axios.get('/api/country/regioncountries?applicationId=' + applicationId);
    }; 

    getBusinessUnit = async () => {
        return await axios.get('/api/businessunit/getbsu');
    };
}